import { store, getContext } from "@wordpress/interactivity";

const { state } = store("tbf-blocks", {
	state: {
		get isSection1Visible() {
			return state.visibleSectionID === "section1";
		},
		get isSection2Visible() {
			return state.visibleSectionID === "section2";
		},
		get isSection3Visible() {
			return state.visibleSectionID === "section3";
		},
		get isSection4Visible() {
			return state.visibleSectionID === "section4";
		},
		get isS1Q1Visible() {
			return state.visibleQuestionID === "section1question1";
		},
		get isS1Yes1Visible() {
			return state.visibleYes === "s1yes1";
		},
		get isS2Q1Visible() {
			return state.visibleQuestionID === "section2question1";
		},
		get isS2Q2Visible() {
			return state.visibleQuestionID === "section2question2";
		},
		get isS2Q3Visible() {
			return state.visibleQuestionID === "section2question3";
		},
		get isS2Q4Visible() {
			return state.visibleQuestionID === "section2question4";
		},
		get isS2Yes1Visible() {
			return state.visibleYes === "s2yes1";
		},
		get isS2Yes2Visible() {
			return state.visibleYes === "s2yes2";
		},
		get isS3Q1Visible() {
			return state.visibleQuestionID === "section3question1";
		},
		get isS3Q2Visible() {
			return state.visibleQuestionID === "section3question2";
		},
		get isS3Q3Visible() {
			return state.visibleQuestionID === "section3question3";
		},
		get isS3Q4Visible() {
			return state.visibleQuestionID === "section3question4";
		},
		get isS3Yes1Visible() {
			return state.visibleYes === "s3yes1";
		},
		get isS3Yes2Visible() {
			return state.visibleYes === "s3yes2";
		},
		get isS4Q1Visible() {
			return state.visibleQuestionID === "section4question1";
		},
		get isS4Yes1Visible() {
			return state.visibleYes === "s4yes1";
		},
		get isS4Yes2Visible() {
			return state.visibleYes === "s4yes2";
		},
	},
	actions: {
		getNextSection: (event) => {
			let el = event.target;
			let parentSection = el.closest(".decision-tree__branch");
			let siblingSection = parentSection.nextElementSibling;
			let adjacentQuestions = parentSection.querySelectorAll(
				".decision-tree__question",
			);

			let currentIndex = Array.prototype.indexOf.call(
				adjacentQuestions,
				el.closest(".decision-tree__question"),
			);

			if (currentIndex >= 0 && currentIndex < adjacentQuestions.length - 1) {
				console.debug("show next question", adjacentQuestions);
				state.visibleQuestionID = adjacentQuestions[currentIndex + 1].id;
			} else if (siblingSection) {
				let siblingSectionQuestion = siblingSection.querySelector(
					".decision-tree__question",
				).id;
				state.visibleQuestionID = siblingSectionQuestion;
				state.visibleSectionID = siblingSection.id;
			} else {
				//Reset to beginning if at the end of the tree temporarily.
				state.visibleQuestionID = "section1question1";
				state.visibleSectionID = "section1";
			}
		},
		getEndPoint: (event) => {
			let el = event.target;
			let yesID = el.dataset.yesId;
			state.visibleYes = yesID;
			state.visibleQuestionID = "";
			state.isResetVisible = true;
		},
		resetTree: () => {
			state.visibleSectionID = "section1";
			state.visibleQuestionID = "section1question1";
			state.visibleYes = "";
			state.isResetVisible = false;
		},
	},
	callbacks: {
		logThis() {
			console.debug("visibleSectionID", state.visibleSectionID);
			console.debug("visibleQuestionID", state.visibleQuestionID);
			console.debug("visibleYes", state.visibleYes);
		},
	},
});


document.addEventListener('DOMContentLoaded', (e) => {
	const buttonOption1 = document.getElementById("buttonOption1");
	const buttonOption2 = document.getElementById("buttonOption2");
	const sectionOption1 = document.getElementById("sectionOption1");
	const sectionOption2 = document.getElementById("sectionOption2");

	buttonOption1.addEventListener("click", () => {
		sectionOption1.classList.remove("is-hidden");
		sectionOption2.classList.add("is-hidden");
		buttonOption1.classList.add("is-active");
		buttonOption2.classList.remove("is-active");
	});

	buttonOption2.addEventListener("click", () => {
		sectionOption2.classList.remove("is-hidden");
		sectionOption1.classList.add("is-hidden");
		buttonOption2.classList.add("is-active");
		buttonOption1.classList.remove("is-active");
	});
});
